module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isCanvasLoaded) ? _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "leaf",
    class: {
      'hide': _vm.prc === 100
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "20.989",
      "height": "16.011",
      "viewBox": "0 0 20.989365 16.010891"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "a",
      "d": "M0 0h1280v800H0z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#b)",
      "transform": "translate(-621.03 -386.895)"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "c",
      "d": "M-9.083-5.833h1280v800h-1280z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "d"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#c",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('path', {
    attrs: {
      "clip-path": "url(#d)",
      "d": "M635.913 399.384c-4.19 2.96-7.787 2.88-9.978.955-.342-.547.248-.983.82-1.418l14.08-9.95c-.157 1.947-.996 7.634-4.922 10.41m-11.23-.735c-1.184-2.636-.137-5.996 4.055-8.958 3.925-2.775 9.718-1.773 11.663-1.308l-14.08 9.95c-.603.395-1.21.805-1.636.315m17.335-10.896c-.03-.042-8.548-2.56-13.93 1.245-5.078 3.586-6.06 7.705-4.224 10.777l-.38-.38s-1.015.232-2.456 1.343c.665.034.84.91 1.292 1.108.808-.474 1.802-1.174 2.072-1.313 2.353 2.938 6.795 3.475 12.055-.243 5.383-3.805 5.6-12.492 5.567-12.535",
      "clip-rule": "evenodd",
      "fill": "#ef4e23",
      "fill-rule": "evenodd"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#b)",
      "transform": "translate(-621.03 -386.895)"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "e",
      "d": "M628.677 389.725c-4.236 3.006-5.296 6.417-4.097 9.095.428.497 1.04.08 1.65-.32l14.232-10.105c-.93-.223-2.75-.57-4.818-.57-2.285 0-4.887.42-6.967 1.9"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "f"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#e",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#f)"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "g",
      "d": "M622.987 387.538h18.052v12.36h-18.054z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "h"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#g",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#h)"
    }
  }, [_c('image', {
    attrs: {
      "overflow": "visible",
      "width": "63",
      "height": "43",
      "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAxCAYAAABnCd/9AAAACXBIWXMAACaZAAAmmQHgIlaIAAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAoxJREFUeNrsWU1KXEEQrp8ecQai m1kEvIBHCLmEhJwn18gu+5wi5ABuA7MIBBQMIUTciKLzutI/r33qvGdXNll0vYIe7Zne1MdX9X3V DTDHHHPMMcd/D3y8udt8fX375dO77urXW3B77Wff3QMfrs/d0fFZ2J2uTj6clp/ck4N31wfd5eWb 7s/Fe1xQ87jI1gNsZUOv1puw/R3BGQcGEZC3C3R+icztM0YEgP0CaJcEO8CEbySxxbUPDKIPRAgf zF2E6UVghPICwvYZ0+cqI6m6ERiH1T5lJnPdLSWEYVnQ5Ik8R4ChQC8Kf8hAKdGwaqX00F+M9Ji0 UMEYTIfHUWyTMblKXgQmARcPxXJCMsGYlKeq+UYE2UaPEVH2GIHew/R+pn1kMlukpkqSGBMcbxwH yMJI4FN1qFTJnsHTAFMYQy6cdwZ6jM+g1FSJolz3ko1sQJUgg4I1Vco9JlNLLPgY6dW3KtcJxL7x WvAxyNqRoDCGAy7tq5KA70mgmq7JzkjQ+5hq802M6UcCG6VUcq0xhoZSEgsGr5SSqscg2+kx0ul8 TAIm+hc2ItegVaVHPgasGDyVj0F46DFghjFcL6V07YD58gbRQPNFn3KVGmPijERheBR2Ni6qgFOe qFGlctDEE22Q65wv1oGBgqABxqCwUq4RbI0EWlWKd58+0MobeXCTAAypp2tLzyfaWWlovHYYk2/v KsB4kTQKiBGDF4GRNDBrRgI0dLUJ5YlWIddSQDECjEyQYOJdyZBco8rHxGtzTx624d/2YREJeYJf iHTL51g8VSXev6XV+pzZfQN0BpDpgPYOvtP+4Y+wu5pmDLmf4JYfyd9/BrTxdo1udRMIcfMcmDnm +Lf4K8AAmMmIPH3MiS4AAAAASUVORK5CYII=",
      "transform": "matrix(.2865 0 0 -.2875 622.987 399.898)"
    }
  })])])]), _c('g', {
    attrs: {
      "clip-path": "url(#b)",
      "transform": "translate(-621.03 -386.895)"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "i",
      "d": "M626.555 399.15c-.58.443-1.175.882-.828 1.437 2.215 1.953 5.85 2.036 10.084-.972 3.97-2.82 4.816-8.592 4.976-10.57l-14.23 10.104z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "j"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#i",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#j)"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "k",
      "d": "M624.964 388.714h16.48v14.323h-16.48z"
    }
  })]), _c('clipPath', {
    attrs: {
      "id": "l"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#k",
      "overflow": "visible",
      "width": "100%",
      "height": "100%"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#l)"
    }
  }, [_c('image', {
    attrs: {
      "overflow": "visible",
      "width": "58",
      "height": "50",
      "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA1CAYAAAD2xDO5AAAACXBIWXMAACboAAAm6AEWeMBbAAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAoRJREFUeNrsWkuKG0EMrSdVGw+B DMx+yDYHmENknXvkFLlCDpFdIJBzzGYWs8gyDISEWUwgH2K3Ul3V/nXKbvXSzy4Q2E1tXkt6epI6 hPM5zYPhg58f394svty/bp++XwdtOFCahRCbP2jmHy7fvP+0ehyH9xLoF8vHb6+Wjw8v0QgNeDSz JWbzz+nffvBBEmBtG0S7gIIkwJPnFb8ztq1TAa8GQYuYLkYlwd45VNtsh8Abyt3OgoAn7IGEaRdP PanTxWxEvJ6dOYAUq8Brv4895ysOrYPviGFlJNgD/scT94Z8NiI5I27PoysNRJ4vhIcx8JIAp1K3 NhaBh4xrJOytY8aUH20ygMTzCZUlr8uY53Odz/kuNGyf+a6r8+PgN2xvwuP5oG627wUBjcLbIvLD 2l76mqhUbB+gBZdP5ICG8Cy0xet+kcNDeAjik7fogdfq4vFGveUoxljYZyUk2JQ7jp6u2qvsCXu2 xsaqaVyp8z3bJ3Y0IoWHFS6X54nkraEPe6izqyMKe5g75/tLSpbzvXZxh31WeRTg2ymTHCUjPHgJ T9Y5D7awHwUvjAPMKYQHsn5+JXKmTW95Fhd5Jjlpbs9CeHDK222RA6Yx1qTGBoSEByfhQZQv7MXV z2tmerAovDzGciwtSr6jXKTJeefGZndLy1LqZO1UR85zjbHKfl7C8FuM0xhj5VKnE/p5pqVFt6j0 9POGsqU1Jnlrpa11KLz+DYFM3gp8A8zseaKPEwrhO8OebkVttiHyMYW3U+tPaZhh1qqFbGXwR8J4 CG1jtoyHc765+IXZs6+wxWVA5AEv8W+Q+OMgeJk9v5P51TtoczXccBz30UUCfxvO53zCPwEGALgk kiMRmnxMAAAAAElFTkSuQmCC",
      "transform": "matrix(.2842 0 0 -.2865 624.964 403.037)"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "c100 small",
    class: ['p' + _vm.prc, {
      'hide': _vm.prc === 100
    }]
  }, [_c('span'), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "text",
    class: {
      'hide': _vm.prc === 100
    }
  }, [_vm._v("Loading assets...")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slice"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "fill"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-457657a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preloader.vue
// module id = 290
// module chunks = 0